import { useGetMediaLibFilesMutation } from "@api/media-library";
import { useMemo } from "react";
import type { IMediaFile } from "@/shared/types";
import { MEDIA_LIB_FILES_QUERY_KEY } from "../../constants";
import { useMediaLibRevelantUploadingFiles } from "../../hooks";
import {
  MEDIA_LIB_PANEL_MASONRY_COLS,
  MEDIA_LIB_PANEL_MASONRY_FAKE_CELLS,
  MEDIA_LIB_PANEL_MASONRY_GAPS,
  MEDIA_LIB_PANEL_MASONRY_SKELETON_HEIGHTS,
} from "../main-panel/constants";
import { MediaLibFile, MediaLibFileUploading } from "./file";
import { useMediaLibFilesCtx } from "./media-lib-files.ctx";

interface IProps {
  files: IMediaFile[];
  colIdx: number;
}

export const MediaLibFilesColumn = ({ files, colIdx }: IProps) => {
  const { category, selectedFolderId } = useMediaLibFilesCtx();

  const [, { isLoading }] = useGetMediaLibFilesMutation({
    fixedCacheKey: MEDIA_LIB_FILES_QUERY_KEY,
  });

  const allUploadingFiles = useMediaLibRevelantUploadingFiles({
    selectedFolderId,
    category,
  });

  const uploadingFiles = useMemo(() => {
    return allUploadingFiles.filter(
      (_, idx) => idx % MEDIA_LIB_PANEL_MASONRY_COLS === colIdx,
    );
  }, [allUploadingFiles, colIdx]);

  return (
    <div
      className="tw-grid tw-h-full tw-grid-flow-row tw-content-start"
      style={{ gap: MEDIA_LIB_PANEL_MASONRY_GAPS }}
    >
      {uploadingFiles.map((file) => (
        <MediaLibFileUploading key={file.id} uploadingFile={file} />
      ))}

      {files.map((file) => (
        <MediaLibFile key={file._id} fileData={file} />
      ))}

      {isLoading && (
        <div className="tw-relative tw-w-full">
          <div
            className="tw-absolute tw-left-0 tw-top-0 tw-grid tw-w-full tw-grid-flow-row tw-content-start"
            style={{
              gap: MEDIA_LIB_PANEL_MASONRY_GAPS,
            }}
          >
            {Array.from(
              { length: MEDIA_LIB_PANEL_MASONRY_FAKE_CELLS },
              (_, idx) => (
                <div
                  className="tw-w-full  tw-animate-skeleton-loading tw-rounded tw-bg-blue-50"
                  key={idx}
                  style={{
                    height:
                      MEDIA_LIB_PANEL_MASONRY_SKELETON_HEIGHTS[
                        colIdx % MEDIA_LIB_PANEL_MASONRY_SKELETON_HEIGHTS.length
                      ][idx % MEDIA_LIB_PANEL_MASONRY_SKELETON_HEIGHTS.length],
                  }}
                />
              ),
            )}
          </div>
        </div>
      )}
    </div>
  );
};
